var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "a-modal",
        {
          attrs: {
            title: "预览",
            okText: "确认",
            cancelText: "下载",
            width: "80vw",
            visible: "",
          },
          on: { cancel: _vm.handleClose },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c("a-button", { on: { click: _vm.handleDownload } }, [
                _vm._v(" 下载 "),
              ]),
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
                [_vm._v(" 确认 ")]
              ),
            ],
            1
          ),
          _c("a", {
            ref: "downbtn",
            staticStyle: { display: "none" },
            attrs: { href: _vm.url.download },
          }),
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100%",
                overflow: "hidden",
              },
            },
            [
              _vm.type == "pdf"
                ? _c("iframe", {
                    staticStyle: {
                      width: "100%",
                      height: "calc(100% + 54px)",
                      border: "0",
                      "margin-top": "-54px",
                    },
                    attrs: { id: "iframe", src: _vm.url.preview },
                  })
                : _c("img", {
                    staticStyle: { "max-width": "100%", "max-height": "100%" },
                    attrs: { src: _vm.url.preview },
                  }),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }